import {
  baseRole,
  profilePermission,
  roleProfile,
} from "../../sales/roleProfiles";
import { isFullAccessRole, SALES_ROLES } from "../../sales/roles";
type Params = {
  action: string;
  resource: string;
  record?: Record<string, any>;
};
export const canAccess = (
  role: string | undefined,
  { resource, action }: Params,
) => {
  if (isFullAccessRole(role)) return true;
  // Project roadmaps remain in preparation for this release.
  if (resource === "work_projects") return false;
  if (
    !role ||
    (!(SALES_ROLES as readonly string[]).includes(role) && !roleProfile(role))
  )
    return false;
  const configured = profilePermission(role, resource, action);
  if (configured !== undefined) return configured;
  role = baseRole(role);
  if (
    [
      "tasks",
      "task_comments",
      "expenses",
      "task_contacts",
      "profile",
      "help",
      "workspace",
      "activity_log",
    ].includes(resource)
  )
    return true;
  if (["project_lookup", "project_lookup_active"].includes(resource))
    return ["list", "show", "read"].includes(action);
  if (resource === "calendar") return true;
  if (
    [
      "contacts",
      "companies",
      "contact_notes",
      "contacts_summary",
      "companies_summary",
      "counterparties",
    ].includes(resource)
  )
    return role === "junior_manager" && action !== "merge";
  if (resource === "tags")
    return (
      role === "junior_manager" && ["list", "show", "read"].includes(action)
    );
  return false;
};
